
define('text!modules/campaign/templates/advertiserFreqCap.html',[],function () { return '{{#advertiserFreqCap}}\n<span class="cap-info">(Advertiser Cap of <span class="cap-details">{{advertiserFrequencyType}} {{advertiserFrequencyAmount}} <span style="text-transform: none">per</span> {{advertiserFrequencyInterval}}</span>)</span>\n{{/advertiserFreqCap}}\n';});

